<template>
  <section>
    <loading v-if="isLoading" :isLoading="isLoading"></loading>
    <div class="columns m-b-10 m-t-10 is-gapless">
      <!-- NOTE: this is here unfortunately because of a weird Chrome bug which causes the page to scroll when content height of the first child changes -->
      <div class="vanish">
        <p>Lorem, ipsum dolor.</p>
      </div>
      <div
        class="column is-7"
        :class="{
          'm-r-10': $mq.resize && $mq.above($mv.tablet),
          'm-b-10': $mq.resize && $mq.below($mv.tablet),
        }"
      >
        <card
          :red="true"
          :isButtonHiddenMobile="true"
          :subtitle="solutions"
          :background="solutions_image"
          :title="'solutions'"
          :to="`solutions/${solutionsInitialRoute}`"
          height="70vh"
        ></card>
      </div>
      <div class="column">
        <div class="columns is-marginless is-gapless flex-column">
          <div
            :class="{ 'm-b-10': $mq.resize && $mq.below($mv.tablet) }"
            class="column m-b-10"
          >
            <card
              :red="true"
              :isButtonHiddenMobile="true"
              :subtitle="about"
              :background="about_image"
              :title="'about us'"
              to="about"
              height="calc(35vh - 5px)"
            ></card>
          </div>
          <div
            :class="{ 'm-b-10': $mq.resize && $mq.below($mv.tablet) }"
            class="column"
          >
            <card
              :red="true"
              :isButtonHiddenMobile="true"
              :subtitle="capabilities"
              :background="capabilities_image"
              :title="'capabilities'"
              :to="`capabilities/${capabilitiesInitialRoute}`"
              height="calc(35vh - 5px)"
            ></card>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-marginless is-gapless">
      <div
        :class="{
          'm-r-10': $mq.resize && $mq.above($mv.tablet),
          'm-b-10': $mq.resize && $mq.below($mv.tablet),
        }"
        class="column is-5"
      >
        <card
          :red="true"
          :isButtonHiddenMobile="true"
          :subtitle="contact"
          :background="contact_image"
          :title="'contact us'"
          to="contact"
          height="70vh"
        ></card>
      </div>
      <div
        :class="{ 'm-b-10': $mq.resize && $mq.below($mv.tablet) }"
        class="column m-b-10"
      >
        <card
          :red="true"
          :isButtonHiddenMobile="true"
          :top="true"
          :subtitle="careers"
          :background="careers_image"
          :title="'careers'"
          to="careers"
          height="70vh"
        ></card>
      </div>
    </div>
  </section>
</template>

<script>
import { bus } from "@/main";

export default {
  data() {
    return {
      solutions: "...",
      about: "...",
      capabilities: "...",
      contact: "...",
      careers: "...",
      about_image: "#",
      capabilities_image: "#",
      careers_image: "#",
      contact_image: "#",
      solutions_image: "#",
      loading: 0,
      loaded: 0,
      isLoading: false,
      capabilitiesInitialRoute: null,
      solutionsInitialRoute: null,
    };
  },
  mounted() {
    bus.$on("capabilitiesInitialRoute", (value) => {
      this.capabilitiesInitialRoute = value;
    });
    bus.$on("solutionsInitialRoute", (value) => {
      this.solutionsInitialRoute = value;
    });
  },
  created() {
    this.axios
      .get(
        `https://${this.baseURL()}/api/singletons/get/homepage?token=8864674b01000e6d7d030ef8c41e72`
      )
      .then((data) => {
        // localStorage.setItem('about', JSON.stringify(data.data));
        // send the slider images in an event object
        console.log(this.bus);
        bus.$emit("sliderImages", data.data["slider_images"]);
        this.solutions = data.data["solutions"];
        this.about = data.data["about"];
        this.capabilities = data.data["capabilities"];
        this.contact = data.data["contact"];
        this.careers = data.data["careers"];
        this.about_image = `https://${this.baseURL()}${
          data.data["about_image"]["path"]
        }`;
        this.capabilities_image = `https://${this.baseURL()}${
          data.data["capabilities_image"]["path"]
        }`;
        this.careers_image = `https://${this.baseURL()}${
          data.data["careers_image"]["path"]
        }`;
        this.contact_image = `https://${this.baseURL()}${
          data.data["contact_image"]["path"]
        }`;
        this.solutions_image = `https://${this.baseURL()}${
          data.data["solutions_image"]["path"]
        }`;

        // subscribe to loading event to know how many images are loading
        this.$on("loading", () => {
          this.isLoading = true;
          this.loading++;
        });

        // detect when loading is finished
        this.$on("loaded", () => {
          this.loaded++;
          // working dynamically regardless of how many images are on page!
          if (this.loaded === this.loading) this.isLoading = false;
        });
      });
  },
};
</script>

<style scoped lang="scss">
.vanish {
  visibility: hidden;
  max-width: 1px;
  @media (max-width: 770px) {
    display: none;
  }
}

.m-b-2vh {
  margin-bottom: 1vh !important;
}
</style>



// WEBPACK FOOTER //
// homeCards.vue?2564de08